module.exports = __webpack_public_path__ + "media/images/og-bialoleka-529409325319d670a3eb08adda282933.jpg";